var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",style:(`width: ${_vm.$vuetify.breakpoint.xs ? 30 : 50}px`)},[_c('v-icon',{style:(_vm.isEmbed ? `color: #${_vm.embed.customization.alternative}` : ''),attrs:{"color":!_vm.isEmbed ? 'primary' : '',"size":_vm.$vuetify.breakpoint.xs ? 30 : 50}},[_vm._v("\n    "+_vm._s(_vm.game.sport.icon)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }